var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000","strokeWidth":"2"},React.createElement("path",{"d":"M64 369L85 390 64 411","transform":"translate(-62 -368) matrix(-1 0 0 1 149 0)"}))));
}

ChevronLeft.defaultProps = {"width":"24","height":"44","viewBox":"0 0 24 44"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
